<div class="modal-wrapper" [formGroup]="form">
    <nz-radio-group formControlName="selectedCompany">
        <label *ngFor="let company of companies" nz-radio [nzValue]="company.companyId">
            {{ company.name }}
        </label>
    </nz-radio-group>
    <div class="buttons">
        <ds-button class="confirm" [width]="'small'"  [text]="'modal-companies.button' | translate" [isDisabled]="!form.value.selectedCompany" (click)="confirmSelection()"></ds-button>
    </div>
</div>